import React from 'react';
// import { styled, createTheme, ThemeProvider } from '@mui/material/styles';



import { DataGrid } from '@mui/x-data-grid';

import { LicenseInfo } from '@mui/x-data-grid-pro';
const REACT_APP_GRID = process.env.REACT_APP_GRID
LicenseInfo.setLicenseKey(REACT_APP_GRID);




export default function ParetoDistanceTable(props) {


    const  ParetoTable  = {
        columns: [
        {field: 'id', headerName: 'Id',hide: true},
        {field: 'Distance in Miles', headerName: 'Distance in Miles', flex: 1, sortable: false, editable: false},
        {field: 'Point Count', headerName: 'Order Count', editable: false, flex:1, sortable:false, headerAlign: 'center', type: 'number', hide: false},
        {field: 'Percentage', headerName: 'Cumulative Percentage', editable: false,flex:1, sortable:false, headerAlign: 'center', type: 'number', hide:false},
        ], 
        rows: props.resultsDistanceInTable
        }


    return (
        <div style={{ height: 400, width: '100%' }}>

                <DataGrid 
                disableColumnSort
                disableSelectionOnClick
                showCellRightBorder
                showColumnRightBorder
                showCellLeftBorder
                disableColumnMenu
                hideFooterPagination

                    {...ParetoTable} 
                />

            </div>


    )
}